import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var mq = "@media screen and ".concat(componentTheme.phoneBreakPoint);
  return {
    content: _defineProperty({
      borderRadius: componentTheme.contentBorderRadius,
      backgroundColor: componentTheme.contentBackgroundColor,
      boxShadow: componentTheme.contentBoxShadow,
      transition: "".concat(componentTheme.contentTransitionDuration, " ease"),
      maxWidth: componentTheme.contentMaxWidth,
      margin: "".concat(componentTheme.contentMargin, " auto"),
      border: "1px solid ".concat(componentTheme.contentBorderColor)
    }, mq, {
      margin: "".concat(componentTheme.phoneContentMargin, " auto")
    })
  };
};
export default generateStyle;